export class UserMenuItem {
  description;
  allowed: boolean;
  allowedObjects;

  constructor() {
    this.allowed = true;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/user-menu-item.ts